const query = (id, isPreview) => `
{
  breadcrumbWrapper(id: "${id}", preview: ${isPreview}){
    internalTitle
    heading
    isRegionalBreadcrumb
    breadcrumbTitle
    firstBreadcrumbPathname
    variant
    textUnderHeading
    shareThisEnabled
    iconLink {
      name
      url
      label
      title
      target
      scrollToElementId
      imageType
      gaEventClass
      gaEventLabel
      ariaLabel
    }
      link {
        name
        url
        label
        title
        target
        scrollToElementId
        imageType
        gaEventClass
        gaEventLabel
        ariaLabel
      }
      socialLinks {
        internalTitle
        linkCollection{
          items{
            title
            url
            ariaLabel
            images{
              altText
              imageMobile {
                title
                description
                contentType
                fileName
                size
                url
                width
                height
              }
              imageDesktop {
                title
                description
                contentType
                fileName
                size
                url
                width
                height
              }

            }
          }
        }
      }
      isBreadcrumb
      pressreleaseCollection{
        items{
            ...on PressReleaseByYear{
              year
              url{
                url
              label
              }
            }
          
        }
  
        }
    regionalBreadcrumbsCollection(limit:10){
      items{
        name
        url
        label
        title
        target
        scrollToElementId
        imageType
        gaEventClass
        gaEventLabel
        ariaLabel
      }
    }
  }
}
`
module.exports = { query }